module.exports = __webpack_public_path__ + "static/media/fly0167.ac6fca3e.webp";